import classnames from 'classnames';
import { Icon, Spinner } from '@toggle/design-system';
import React from 'react';

import styles from './UnreadConversation.module.scss';

interface UnreadConversationProps {
  status: string | null | undefined;
  question?: string;
  conversationName: string;
}

export const UnreadConversation = ({
  status,
  question,
  conversationName,
}: UnreadConversationProps) => {
  const renderStatusIcon = (status: string | null | undefined) => {
    switch (status) {
      case 'Processing':
        return <Spinner size="extraSmall" useAccentColor />;
      case 'Error':
        return (
          <Icon
            iconName="ExclamationCircle"
            size={12}
            fillColor="var(--icon-critical)"
          />
        );

      case 'Done':
        return (
          <Icon
            iconName="CheckmarkCircle"
            size={12}
            fillColor="var(--icon-success)"
          />
        );
      default:
        return (
          <Icon
            iconName="CheckmarkCircle"
            size={12}
            fillColor="var(--icon-success)"
          />
        );
    }
  };

  return (
    <div
      className={styles.itemWrapper}
      data-testid={`unread-conversation-${conversationName}`}
    >
      <div
        className={styles.iconWrapper}
        data-testid={`unread-conversation-status-${status}`}
      >
        {renderStatusIcon(status)}
      </div>
      <div
        className={classnames(styles.styledText, {
          [styles.processing]: status === 'Processing',
        })}
      >
        {question || conversationName}
      </div>
    </div>
  );
};
